var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-card-consumpt-audit",
    },
    [
      _c(
        "div",
        { staticClass: "mb16" },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("pc_biz_mall_order_code" /**订单编号 */)) +
                "：" +
                _vm._s(_vm.info.orderCode)
            ),
          ]),
          _c(
            "yxt-button",
            {
              staticClass: "ml16",
              attrs: { type: "text" },
              on: { click: _vm.openDetail },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("pc_biz_mall_order_detail" /**查看订单详情 */))
              ),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "mb16" }, [
        _c("span", [
          _vm._v(
            _vm._s(_vm.$t("pc_biz_mall_order_sum" /**订单总金额 */)) +
              "：￥" +
              _vm._s(_vm._f("numWithThousandth")(_vm.info.totalAmount))
          ),
        ]),
      ]),
      _c("div", { staticClass: "mb16" }, [
        _c("span", [
          _vm._v(
            _vm._s(_vm.$t("pc_biz_mall_order_time" /**订单创建时间 */)) +
              "：" +
              _vm._s(_vm.info.createTime)
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }